import React from 'react';
import clsx from 'clsx';
import { Box, Grid } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    infoCard: {
        height: 80,
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            height: 'auto',
        },
    },
    cardPiece: {
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            textAlign: 'center',
        },
        '&:first-child': {
            borderRight: `3px ${theme.palette.primary.main} solid`,
            [theme.breakpoints.down('sm')]: {
                borderRight: 'none',
                borderBottom: `3px ${theme.palette.primary.main} solid`,
            },
        },
        '&:last-child': {
            borderRight: `3px ${theme.palette.primary.main} solid`,
            [theme.breakpoints.down('sm')]: {
                borderRight: 'none',
                borderBottom: `3px ${theme.palette.primary.main} solid`,
            },
            '&$clickable': {
                cursor: 'pointer',
                '&:hover': {
                    color: theme.palette.primary.main,
                },
            },
        },
    },
    clickable: {},
}));

const InfoCard = ({ number, label, onClick, flexBase = '80px', disableGrid, width, boxProps }) => {
    const classes = useStyles();
    const content = (
        <React.Fragment>
            <Box
                className={classes.cardPiece}
                flex={`0 1 ${flexBase}`}
                justifyContent="center"
                fontSize={36}
            >
                {number ?? 0}
            </Box>
            <Box
                className={clsx({ [classes.cardPiece]: true, [classes.clickable]: !!onClick })}
                flex="1 1"
                fontSize={18}
                onClick={onClick}
            >
                {label}
            </Box>
        </React.Fragment>
    );

    return disableGrid ? (
        <Box className={classes.infoCard} width={width} {...boxProps}>
            {content}
        </Box>
    ) : (
        <Grid item className={classes.infoCard} md={6} sm={12}>
            {content}
        </Grid>
    );
};

export default InfoCard;
